import React, {useState} from "react";
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';


const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'firstName',
      headerName: '이름',
      width: 150,
      editable: true,
    },
    {
      field: 'lastName',
      headerName: '오오',
      width: 150,
      editable: true,
    },
    {
      field: 'age',
      headerName: '연령',
      type: 'number',
      width: 110,
      editable: true,
    },
    {
      field: 'fullName',
      headerName: 'Full name',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      width: 160,
      valueGetter: (params:any) =>
        `${params.row.firstName || ''} ${params.row.lastName || ''}`,
    },
  ];
  
  const rows = [
    { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
    { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
    { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
    { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
    { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
    { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
    { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
    { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
    { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
  ];
  
  const Datagride_hanwool = () => {
    const [searchInput, setSearchInput] = useState("");
  
    const filteredRows = rows.filter((row) => {

      if (row.firstName && row.lastName && row.age){
        return (
          row.firstName.toLowerCase().includes(searchInput.toLowerCase()) ||
          row.lastName.toLowerCase().includes(searchInput.toLowerCase()) ||
          row.age.toString().includes(searchInput.toLowerCase())
        )
      }
      
    });


  
    return (
      <Box sx={{ height: 400, width : "800px" }}>
        <input type="text" value={searchInput} onChange={e => setSearchInput(e.target.value)}placeholder="Search..."/>

        <DataGrid
          rows={filteredRows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
          checkboxSelection
          disableSelectionOnClick
          experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>
    );
  }


  export default Datagride_hanwool